import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { PcsTranslateParser } from '@app/core/translate/translate.parser';
import { PcsTranslateService } from '@app/core/translate/translate.service';
import { TranslateLoader, TranslateModule, TranslateParser } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

const translationsPath = 'rest/translations?lang=';

export function httpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, translationsPath, '');
}

/**
 * Translations module that will fetch translations on startup.
 * */
export const translateModule = TranslateModule.forRoot({
  loader: {
    provide: TranslateLoader,
    useFactory: httpLoaderFactory,
    deps: [HttpClient]
  }
});

@NgModule({
  imports: [
    translateModule
  ],
  providers: [
    PcsTranslateService,
    {
      provide: TranslateParser,
      useClass: PcsTranslateParser
    }
  ]
})
export class PcsTranslateModule {
}
